/* eslint-disable no-unused-expressions */
import { Status } from '../constants/status';

export const getUserToken = () => localStorage.getItem('user_token');

export const getCurrentUser = () => {
  let user = null;
  try {
    user =
      localStorage.getItem('current_user_data') != null
        ? JSON.parse(localStorage.getItem('current_user_data'))
        : null;
  } catch (error) {
    console.log('>>>>: src/helpers/Utils.js  : getCurrentUser -> error', error);
    user = null;
  }
  return user;
};

export const setCurrentUser = (user) => {
  try {
    if (user) {
      localStorage.setItem('current_user_data', JSON.stringify(user));
    } else {
      localStorage.removeItem('current_user_data');
    }
  } catch (error) {
    console.log('>>>>: src/helpers/Utils.js : setCurrentUser -> error', error);
  }
};

export const setToken = (token) => {
  try {
    if (token) {
      localStorage.setItem('user_token', token);
    } else {
      localStorage.removeItem('user_token');
    }
  } catch (error) {
    console.log('>>>>: src/helpers/Utils.js : setTokenError -> error', error);
  }
};

export const convertBooleanToYesOrNo = (val) => (val ? 'YES' : 'NO');

export const getFormattedStatus = (status) => {
  let reg = /_([a-z]|[A-Z])$/; // regular expression to check if the status ends with _S. S - some character
  if (reg.test(status)) {
    status = status.slice(0, status.length - 2);
  }
  if (status) {
    return status.toLowerCase();
  } else {
    return null;
  }
};

export const getFormattedStatusFirstCapital = (status) => {
  let reg = /_([a-z]|[A-Z])$/; // regular expression to check if the status ends with _S. S - some character
  if (reg.test(status)) {
    status = status.slice(0, status.length - 2);
  }
  if (status) {
    return `${status.charAt(0).toUpperCase()}${status.substr(
      1,
      status.length
    )}`;
  } else {
    return null;
  }
};

export const formatStatus = (status) => {
  let split =
    status === Status.draft_by_lender ? [Status.draft] : status.split('_c');
  const final = split[0] && split[0].toUpperCase();
  return final;
};

export const formatReturnStatus = (status) => {
  let splitStr = status.split('_');
  splitStr.length > 1 ? splitStr.pop() : splitStr;
  return splitStr.join('_').toUpperCase();
};

export const isObjectEmptyOrNull = (obj) => {
  return !obj || Object.keys(obj).length === 0;
};

export const getFormattedMoneyString = (inp) => {
  let numbered = Number(inp);
  return isNaN(numbered) ? inp : `$${numbered.toFixed(2)}`;
};

export const getFormattedMoneyStringFromString = (inp) => {
  if (inp) {
    const replaceString = inp?.startsWith('$') ? inp.replace('$', '') : inp;
    const numbered = replaceString ? Number(replaceString) : inp;
    return isNaN(numbered) ? inp : numbered;
  } else {
    return '';
  }
};

export const getNumberFromMoneyString = (inp) => {
  if (!inp) return '';
  if (typeof inp === 'number') return inp;
  return +inp.replace(/[^0-9\.]/g, '');
};

export const getFormattedDateString = (dateString) => {
  if (!dateString) return '';
  let splitted = dateString.split('T')[0].split('-');
  return `${splitted[1]}/${splitted[2]}/${splitted[0]}`;
};

export const getFormattedDate2String = (dateString) => {
  if (!dateString) return '';
  let splitted = dateString.split('T')[0].split('-');
  return `${splitted[1]}/${splitted[2]}/${splitted[0].slice(2, 4)}`;
};

export const formatUrl = (url) => {
  return url && url.startsWith('http') ? url : `http://${url}`;
};

export const formatReferralLink = (url, userId) => {
  if (url && url.includes('ref_id')) {
    return url.replace('{{userid}}', userId);
  } else if (url) {
    return `${url}&ref_id=${userId}`;
  }
  return url;
};

export const isFunctionalComponent = (Component) => {
  return (
    typeof Component === 'function' && // can be various things
    !(
      (
        Component.prototype && // native arrows don't have prototypes
        Component.prototype.isReactComponent
      ) // special property
    )
  );
};

export const makeFirstLetterCapital = (text) => {
  if (text && typeof text === 'string') {
    const firstLetter = text.charAt(0).toUpperCase();
    const remainLetter = text.slice(1, text.length);
    return `${firstLetter}${remainLetter?.toLowerCase()}`;
  } else {
    return text;
  }
};

export const formatPhoneNumber = (phoneNumber) => {
  const phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  return phoneNumber.replace(phoneRegex, '($1) $2-$3');
};

export const getBodyType = (bodyTypes, value) =>
  bodyTypes.find((type) => type.value === value)?.display;

export const getUserUsuallyWears = (usuallyWears, value) =>
  usuallyWears.find((size) => size.value === value)?.display ?? '';

export const getBraSize = (braSize, value) =>
  braSize.find((size) => size.value === value)?.display ?? '';

export const getHeightData = (heightData, value) =>
  heightData.find((size) => size.value === value)?.display ?? '';

export const removeEmptyProperties = (object, keepFalseValues = true) => {
  if (!object || typeof object !== 'object') {
    throw new TypeError(
      'Invalid argument passed to the function `removeEmptyProperties`. Object required'
    );
  }

  Object.entries(object).forEach(([prop, value]) => {
    if (typeof value === 'object') {
      if (!value && value !== 0 && (!keepFalseValues || value !== false)) {
        delete object[prop];
      }
      // removeEmptyProperties(value);
      if (Object.keys(value).length === 0) {
        delete object[prop];
      }
    }
  });
};
